import React, { useState } from 'react'
import {
  Wrapper,
  Row,
  Column,
  Title,
  Content,
  List,
  ListItem,
  ColumnWrapper,
  Header,
} from './index.styled'

const Features = ({ data }) => {
  const { listInfo, notes } = data
  const [activeList, setActiveList] = useState(null)

  const tooggleList = (title) => {
    if (activeList === title) {
      setActiveList(null)
    } else {
      setActiveList(title)
    }
  }

  return (
    <Wrapper>
      {listInfo.map((item, index) => {
        const { title, lists, multiColumn } = item

        return multiColumn ? (
          <Row key={`service-features-list-${index}`} $direction="row">
            {lists.map((listItem, index) => {
              return (
                <ColumnWrapper key={`service-features-column-${index}`}>
                  <Header
                    onClick={() => {
                      tooggleList(listItem.title)
                    }}
                  >
                    <Title
                      key={`service-features-list-title-${index}`}
                      $active={activeList === listItem.title}
                    >
                      {listItem.title}
                    </Title>
                  </Header>
                  <Content $active={activeList === listItem.title}>
                    <Column key={`service-features-list-column-${index}`}>
                      <List>
                        {listItem.list.map((item, index) => {
                          return (
                            <ListItem
                              key={`service-features-list-list-${index}`}
                            >
                              {item}
                            </ListItem>
                          )
                        })}
                      </List>
                    </Column>
                  </Content>
                </ColumnWrapper>
              )
            })}
          </Row>
        ) : (
          <Row key={`service-features-list-${index}`}>
            <Header onClick={() => tooggleList(title)}>
              {title.map((title, index) => {
                return (
                  <Title
                    key={`service-features-list-title-${index}`}
                    $active={activeList === title}
                  >
                    {title}
                  </Title>
                )
              })}
            </Header>
            <Content $active={activeList === title}>
              {lists.map((listItem, index) => {
                return (
                  <Column
                    $length={lists.length}
                    key={`service-features-list-column-${index}`}
                  >
                    <List>
                      {listItem.list.map((item, index) => {
                        return (
                          <ListItem
                            key={`service-features-list-child-list-${index}`}
                          >
                            {item}
                          </ListItem>
                        )
                      })}
                    </List>
                  </Column>
                )
              })}
            </Content>
          </Row>
        )
      })}
      <List>
        {notes.map((item, index) => {
          return <ListItem key={`notes-${index}`}>{item}</ListItem>
        })}
      </List>
    </Wrapper>
  )
}

export default Features
